import Compats from '../../../../../../../components/compats-widget/highlight';
import { COMPONENT_TYPES } from '../../../../../../../components/header-with-plugins/helpers/constants';

export default {
  [COMPONENT_TYPES.COMPATS]: {
    component: Compats,
  },
};
